export const ExportFileIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.06528 20.166H13.9319C15.4721 20.166 16.2422 20.166 16.8304 19.8662C17.3479 19.6026 17.7686 19.1819 18.0322 18.6644C18.332 18.0762 18.332 17.3061 18.332 15.766V9.15518C18.332 8.48256 18.3319 8.14625 18.256 7.82975C18.1886 7.54915 18.0775 7.28091 17.9267 7.03486C17.7566 6.75734 17.5188 6.51953 17.0432 6.04391L14.1207 3.12137C13.6451 2.64575 13.4073 2.40795 13.1297 2.23788C12.8837 2.0871 12.6154 1.97599 12.3348 1.90862C12.0183 1.83264 11.682 1.83264 11.0094 1.83264H8.06528C6.52514 1.83264 5.75507 1.83264 5.16681 2.13237C4.64936 2.39603 4.22867 2.81672 3.96502 3.33417C3.66528 3.92243 3.66528 4.6925 3.66528 6.23264V9.15518M12.832 2.07965V5.86598C12.832 6.37936 12.832 6.63605 12.9319 6.83213C13.0197 7.00462 13.16 7.14485 13.3325 7.23273C13.5285 7.33264 13.7852 7.33264 14.2986 7.33264H18.0849"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66528 19.584V18.7819C3.66528 16.8567 3.66528 15.8941 4.03995 15.1588C4.36951 14.512 4.89538 13.9861 5.54219 13.6565C6.27751 13.2819 7.2401 13.2819 9.16528 13.2819H12.8319M12.8319 13.2819L9.96737 16.1465M12.8319 13.2819L9.96737 10.4173"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
